import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Loader2, Info } from 'lucide-react';
import { useToast } from '@/components/use-toast';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/components/ui/alert";


// NOTE: All seed data is being loaded directly into the database in batches.
// This component is a placeholder for future data uploading functionality.

export default function DataUploader() {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleUpload = async () => {
    setIsLoading(true);
    toast({
      title: "No Data to Upload",
      description: "The seed data is being loaded directly. This component is a placeholder.",
      variant: "default",
    });
    setIsLoading(false);
  };

  return (
    <div className="max-w-2xl mx-auto p-8">
      <Card>
        <CardHeader>
          <CardTitle>Data Management</CardTitle>
          <CardDescription>
            The initial dataset for this application is being loaded in batches.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Alert>
            <Info className="h-4 w-4" />
            <AlertTitle>System Notice</AlertTitle>
            <AlertDescription>
              There is no new data to upload at this time. Data is being loaded in the background.
            </AlertDescription>
          </Alert>
          <div className="mt-6 flex justify-end">
            <Button onClick={handleUpload} disabled={true}>
              {isLoading ? (
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              ) : (
                'Upload Data'
              )}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}